<template>
  <div>

    <div class="alert alert-info" role="alert" v-if="is_archived">      
      <i :class="icon_status_plan"></i>
      {{ __("forms.KPIIncentivePlan.target_related_to_plan_archived_info") }}
    </div>

    <div class="alert alert-danger" role="alert" v-if="simulation_env">
      {{ __("views.mboSimulation.simulationEnvironment") }}
    </div>

    <!-- Tab Navigation -->
    <ul class="nav nav-tabs" role="tablist">
      <li v-for="(targetByIdentifier, index) in tableTargets" :key="index" class="nav-item">
        <a :class="['nav-link', { active: activeTab === index }]" @click="handleTab(index)" href="#" role="tab">
          {{ targetByIdentifier.identifier }}
        </a>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content mt-3">
      <div v-for="(targetByIdentifier, index) in tableTargets" :key="index" v-show="activeTab === index"
        class="tab-pane fade show active" role="tabpanel">
        <div class="card my-4 mx-3 shadow">
          <div class="card-header text-white d-flex align-items-center justify-content-between px-4"
            :style="'background-color:' + targetByIdentifier.cardColor">
            <h5 class="card-title mb-0">{{ targetByIdentifier.identifier }}</h5>
          </div>
          <div class="card-body px-4">
            <div class="row">
              <div class="col-4">
                <h3 class="text-primary">{{ __('views.trainingRequests.details') }}</h3>
                <!-- Expires At Field -->
                <p class="my-3"><span class="text-voice-title">{{ __("forms.kPITarget.expires_at") }}</span>: {{targetByIdentifier.enchanted_expires_at }}</p>

                <!-- Doc Upload -->
                <p v-if="kpiRequiredFiles || can_upload_documents " class="my-3">
                  <span class="text-voice-title">{{ __("forms.KPIS.consumptives_doc") }}</span>:
                  <span v-if="kpiRequiredFiles" class="text-danger">{{ __("misc.required") }}</span>
                  <span v-else class="text-success">{{ __("misc.optional") }}</span>
                </p>

                <!-- Consumptive Field -->
                <div class="my-3" v-if="can_write">
                  <!-- Label e Campo affiancati -->
                  <div class="d-flex align-items-center">
                    <label class="mr-2 text-voice-title">
                      {{
                        __('forms.EvaluationChart.questions.questions_setting.question12.incentive_curve.value')
                      }} {{
                        __("forms.kPITarget.consumptive")
                      }}:
                    </label>
                    <!-- Campo numero -->
                    <input
                      v-if="kpiSegment.typology === 'number'"
                      @change="updateTarget()"
                      :disabled="disabledConsumptivation"
                      v-model="targetByIdentifier.consumptive"
                      type="number"
                      step="0.01"
                      class="form-control w-50"
                    />

                    <!-- Campo data -->
                    <input
                      v-if="kpiSegment.typology === 'date'"
                      @change="updateTarget()"
                      :disabled="disabledConsumptivation"
                      v-model="targetByIdentifier.date_consumptive"
                      type="date"
                      class="form-control w-50"
                    />

                    <!-- Campo testo -->
                    <select
                      v-if="kpiSegment.typology === 'text'"
                      @change="updateTarget()"
                      :disabled="disabledConsumptivation"
                      v-model="targetByIdentifier.text_consumptive_id"
                      class="form-control w-50"
                    >
                      <option value="">---</option>
                      <option v-for="kpiSegmentGoal in kpiSegmentGoals" :value="kpiSegmentGoal.id">
                        {{ kpiSegmentGoal.text_manual_threshold }}
                      </option>
                    </select>
                  </div>

                  <!-- Messaggio di avviso sotto il campo -->
                  <p v-if="showInfoDocConsumptive" class="mt-2">
                    <i class="fa-solid fa-warning mr-2 text-danger"></i>
                    {{ __("forms.KPIS.consumptives_docs_alert") }}
                  </p>
                </div>


                <div v-else>
                  <p>
                    <span class="text-voice-title">{{
                      __('forms.EvaluationChart.questions.questions_setting.question12.incentive_curve.value') }} {{
                        __("forms.kPITarget.consumptive") }}:
                    </span>{{ targetByIdentifier.enchantedConsumptive }}
                  </p>
                </div>

                <!-- Computed At Field (Modifiable) -->
                <div class="d-flex align-items-center my-3">
                  <label class="mr-2 text-voice-title">{{ __("forms.kPITarget.computed_at") }}:</label>
                  <input v-if="can_write && targetByIdentifier.computed_at != null && !is_archived" @change="updateTarget()"
                    v-model="targetByIdentifier.computed_at" type="date" class="form-control w-50" />
                  <p v-else>{{ targetByIdentifier.enchanted_computed_at }}</p>
                </div>

                <!-- Additional Information -->
                <p class="my-3" v-if="show_performance_percent"><span class="text-voice-title">{{
                  __("forms.KPISegments.threshold") }}:</span> {{ targetByIdentifier.gear }}</p>
                <p class="my-3" v-if="show_reach_percent"><span class="text-voice-title">{{
                  __("forms.kPITarget.percentage_accomplishment") }}</span>: {{
                      targetByIdentifier.percentageAccomplishment }}</p>

                <!-- Alert Message -->
                <div v-if="targetByIdentifier.alertMessage" class="alert alert-warning font-weight-bold">
                  <i class="fas fa-triangle-exclamation"></i> {{ targetByIdentifier.alertMessage }}
                </div>
              </div>

              <div class="col-4 position-relative" v-if="can_download_documents">
                <h3 class="text-primary">{{ __('forms.Activities.documents') }}</h3>
                <!-- No Docs Uploaded -->
                <p class="text-voice-value"
                  v-if="(targetByIdentifier.attachments.length === 0) && (files.length === 0)">{{
                    __('forms.KPIS.no_docs_uploaded') }}</p>

                <!-- Docs Uploaded -->
                <div v-for="attachment in targetByIdentifier.attachments" class="d-flex align-items-center my-2">
                  <a :href="attachment.url" class="mr-2">
                    <i class="fas fa-eye colored-icon"></i>
                  </a>
                  <a href="#" @click="deleteItem(attachment)" class="mr-2" v-if="(can_upload_documents && can_write && !is_archived)">
                    <i class="fas fa-trash text-danger"></i>
                  </a>
                  <span class="text-voice-value">
                    {{ attachment.name }}
                  </span>
                </div>

                <div v-for="(file, index) in files" class="d-flex align-items-center my-2">
                  <a href="#" @click="deleteItem(file, index)" class="mr-2" disabled v-if="!is_archived">
                    <i class="fas fa-trash text-danger"></i>
                  </a>
                  <span class="text-voice-value">
                    {{ file.name }}
                  </span>
                </div>

                <div v-if="loadingUploadFiles" class="position-absolute"
                  style="top: 0; bottom: 0; left: 0; right: 0; display: flex; justify-content: center; align-items: center; background: #f1f1f19c;">
                  <div>
                    <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                    <label>{{ __("misc.loading") }}</label>
                  </div>
                </div>
              </div>

              <div class="col-4" v-if="(can_upload_documents && can_download_documents && can_write && !is_archived)">
                <div class="container-file-upload" @drop="handleFileDrop" @dragover="handleDragOver"
                  @dragleave="fileDragOut" v-bind:style="{ 'background-color': color }">
                  <i class="fa-solid fa-upload colored-icon mb-4 upload-icon"></i>
                  <p class="mb-2">{{ __('forms.Person.permission_tabs.documents.dragDrop') }}</p>
                  <div class="upload-btn-wrapper">
                    <button style="cursor: pointer;" class="btn btn--blue align-center">
                      {{ __('forms.Person.permission_tabs.documents.selectFilefromPC') }}
                    </button>
                    <input type="file" :id="`files-${targetByIdentifier.model_id}`"
                      :ref="`files-${targetByIdentifier.model_id}`" @change="handleFileInput" multiple>
                  </div>
                  <p class="mt-2">{{ __('forms.Person.permission_tabs.documents.max-size') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Icon -->
    <div style="margin-top: 10px; text-align: right" v-if="loadingIcon">
      <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
      <label>{{ __("misc.loading") }}</label>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    this.getTargets(true);
  },
  props: {
    kpi_id: { type: Number, required: true },
    is_admin: { type: Boolean, required: true },
    consumptive_typology: { type: String, required: true },
    open_in_chart: { type: Number, required: true },
    identifiers: { type: Array, required: true },
    question_survey_id: { type: Number, required: false },
    text_goals: { type: Array, required: true },
    can_write: { type: Boolean, required: true },
    can_download_documents: { type: Boolean, required: true },
    can_upload_documents: { type: Boolean, required: true },
    can_delete: { type: Boolean, required: true },
    show_performance_percent: { type: Boolean, required: true },
    show_reach_percent: { type: Boolean, required: true },
    simulation_env: { type: Boolean, required: false, default: false },
    module: { type: String, required: false },
    is_archived: {type: Boolean, required: false, default: false},
    icon_status_plan: {type: String, required: false, default: false}
  },
  data() {
    return {
      kpiRequiredFiles: false,
      activeTab: 0,
      newComputedAt: new Date().toISOString().slice(0, 10),
      loadingIcon: false,
      loadingUploadFiles: false,
      tableTargets: [],
      kpiSegmentGoals: [],
      files: [],
      targetByIdentifier: {},
      kpiSegment: {},
      userUrl: this.is_admin || this.module == 'mbo' ? '' : '-user',
      color: 'white',
      maxFileSize: 10 * 1024 * 1024,
      allowedTypes: [
        'application/pdf',                   // PDF
        'application/msword',                // Word (.doc)
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word (.docx)
        'application/vnd.ms-excel',          // Excel (.xls)
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel (.xlsx)
        'application/vnd.ms-outlook',        // Email (.msg)
        'application/zip',                   // ZIP
        'application/x-zip-compressed',      // ZIP (alternative MIME type)
        'application/pkcs7-mime',            // Firma digitale (.p7m)
        'image/jpeg',                        // JPG
        'image/png',                         // PNG
        'message/rfc822',                    // Email (.eml)
      ],
      errors: '',
      totalSizeUploaded: 0,

    };
  },
  computed: {
    disabledConsumptivation: function () {      
      return this.showInfoDocConsumptive || this.is_archived;
    },
    showInfoDocConsumptive: function() {
      return !!(this.kpiRequiredFiles && (this.targetByIdentifier.attachments.length === 0 && this.files.length === 0));
    },
  },
  methods: {
    handleTab(index) {
      this.activeTab = index;
      this.targetByIdentifier = this.tableTargets[this.activeTab]
    },
    swalOutOufBounds(message) {
      Vue.swal.fire({ text: message, icon: "danger" });
    },
    printDescription(textConsumptiveId) {
      let goal = this.text_goals.find((obj) => obj.id == textConsumptiveId);
      return goal ? goal.description : "";
    },
    getTargets(onMountedComponent = false) {
      this.loadingIcon = true;
      let urlTo = this.open_in_chart
        ? `/kpi-targets-by-kpi-user/${this.kpi_id}/kpi`
        : `/kpi-targets-by-kpi/${this.kpi_id}/kpi`;


      axios
        .get(urlTo, {
          params: {
            question_survey_id: this.question_survey_id,
            availableIdentifiers: this.identifiers
          },
        })
        .then((response) => {
          this.kpiRequiredFiles = response.data.kpiRequiredFiles;
          this.tableTargets = response.data.tableIdentifiers;
          this.kpiSegment = response.data.kpiSegment;
          this.kpiSegmentGoals = response.data.kpiSegmentGoals;

          //Emit MyBoard KPIIncentivePlan List
          Livewire.emit("refreshMyBoardKpiIncentivePlanList");

          if (onMountedComponent) {
            this.setDefaultTab();


          } else {
            this.targetByIdentifier = this.tableTargets[this.activeTab]
            if (this.files.length > 0) {
              this.submitFile()
            }
          }

          if (this.open_in_chart) {
            const refName = `can_enable_question_target_kpi_chart_${this.question_survey_id}`;
            const chartRef = app.__vue__.$refs[refName]?.$refs[`question_target_kpi_chart_${this.question_survey_id}`];
            chartRef ? chartRef.populateKpiTable() : app.__vue__.$refs[`question_target_kpi_chart_${this.question_survey_id}`].populateKpiTable();
            Livewire.emit("refreshGlobalRating");
          }
        })
        .catch(() => { })
        .finally(() => {
          this.loadingIcon = false;
        })
    },
    updateTarget() {
      this.loadingIcon = true;
      let params = {
        kpiTargetData: {
          kpi_id: this.targetByIdentifier.kpi_id,
          identifier_id: this.targetByIdentifier.identifier_id,
          consumptive: this.targetByIdentifier.consumptive,
          date_consumptive: this.targetByIdentifier.date_consumptive,
          text_consumptive_id: this.targetByIdentifier.text_consumptive_id,
          computed_at: this.targetByIdentifier.computed_at,
          expires_at: this.targetByIdentifier.expires_at,
          question_survey_id: this.question_survey_id,
        },
      };
      let urlTo = this.open_in_chart
        ? `/set-kpi-target-user/${this.targetByIdentifier.kpi_id}/kpi/${this.targetByIdentifier.identifier_id}/kpi_target_identifier`
        : `/set-kpi-target/${this.targetByIdentifier.kpi_id}/kpi/${this.targetByIdentifier.identifier_id}/kpi_target_identifier`;

      axios
        .put(urlTo, params)
        .then((response) => {
          if (response.data.message) {
            Vue.swal.fire({
              title: response.data.message,
              icon: "error",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
          }
          this.getTargets();
        })
        .catch(() => {
          Vue.$toast.open({
            message: this.__("misc.unexpected_error"),
            type: 'error',
            position: 'bottom-right'
          });
        })
        .finally(() => {
          this.loadingIcon = true;
          Livewire.emit("refreshMyBoardKpiIncentivePlanList");
          Vue.$toast.open({
            message: this.__("misc.save_successfully"),
            type: 'success',
            position: 'bottom-right'
          });
        });
    },
    deleteItem(item, isFileIndex = null) {
      let html = this.__("misc.delete_file_confirm");
      if (this.targetByIdentifier.attachments.length === 1 && this.kpiRequiredFiles) {
        html += this.__("misc.delete_file_confirm_alert");
      }
      Vue.swal
        .fire({
          title: this.__("misc.delete_confirm"),
          html: html,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.__('misc.confirm'),
          cancelButtonText: this.__('misc.CancelData')
        })
        .then((result) => {
          if (isFileIndex != null) {
            this.files.splice(isFileIndex, 1);
            return true;
          }
          if (result.value) {
            this.loadingUploadFiles = true;
            axios
              .delete(item.delete_route, {
                params: {
                  id: item.id,
                },
              })
              .then((response) => {
                this.getTargets();
                Vue.swal.fire({
                  title: response.data.title,
                  icon: "success",
                });
                this.files = [];
              })
              .catch(function (error) {
                if (error.response.status == 405) {
                  Vue.swal.fire({
                    title: error.response.data.title,
                    html: error.response.data.html,
                    icon: "error",
                  });
                }
              })
              .finally(() => {
                this.loadingUploadFiles = false;
              });
          }
        });
    },
    setDefaultTab() {
      if (this.tableTargets.length > 0) {
        const futureTargetIndex = this.tableTargets.reduce((maxIndex, target, index, arr) => {
          return new Date(target.expires_at) > new Date(arr[maxIndex].expires_at) ? index : maxIndex;
        }, 0);

        this.handleTab(futureTargetIndex);
      }
    },

    verifyConsumptiveExist() {
      if (this.targetByIdentifier.consumptive === null) {
        Vue.swal.fire({
          title: this.__('misc.upload_file'),
          html: this.__('misc.upload_file_text'),
          icon: "success",
        });
      } else {
        this.submitFile();
      }
    },

    submitFile() {
      this.loadingUploadFiles = true;
      let formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append('files[' + i + ']', file);
      }

      formData.append("modelId", this.targetByIdentifier.model_id);

      axios.post(this.targetByIdentifier.post_url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        Vue.swal.fire({
          title: this.__('misc.updated_succesfully'),
          icon: "success",
        });

        this.getTargets();
      }).catch((error) => {
        Vue.swal.fire({
          title: "Errore",
          html: error.response.data.message,
          icon: "error",
        });
      }).finally(() => {
        this.files = [];
        this.totalSizeUploaded = 0;
        this.loadingUploadFiles = false;
      });
    },

    handleFileInput(event) {
      event.preventDefault();
      const files = event.target.files;

      let validation = this.validationFileUpload(files);

      if (validation) {
        this.uploadFile(files);
      }

    },

    handleFileDrop(event) {
      event.preventDefault();
      let files = event.dataTransfer.files;

      let validation = this.validationFileUpload(files);

      if (validation) {
        this.uploadFile(files);
      }
    },

    fileDragOut() {
      this.color = "white";
    },

    handleDragOver(e) {
      e.preventDefault();
      this.color = "#f4f4f4";

    },

    uploadFile(files) {
      for (var i = 0; i < files.length; i++) {
        this.files.push(files[i]);
      }
      this.verifyConsumptiveExist();
    },

    validateMsgFileType(file) {
      const reader = new FileReader();

      reader.onloadend = function (e) {
        const arrayBuffer = e.target.result;
        const uint8Array = new Uint8Array(arrayBuffer);

        // Estrai i primi 8 byte per identificazione
        const hexSignature = Array.from(uint8Array.slice(0, 8))
          .map(byte => byte.toString(16).padStart(2, '0'))
          .join(" ");

        // Magic number per file .msg (OLE Compound File)
        const OLE_MAGIC_NUMBER = "d0 cf 11 e0 a1 b1 1a e1";

        if (hexSignature !== OLE_MAGIC_NUMBER) {
          this.errors += `${files[i].name}: ${this.__('misc.error_file_type')}`;
        }
      };
    },

    validationFileUpload(files) {
      let result = true;
      let fileSize = 0;
      for (var i = 0; i < files.length; i++) {

        if (files[i] && files[i].name.endsWith(".msg")) {
          this.validateMsgFileType(files[i])
        } else if (!this.allowedTypes.includes(files[i].type)) {
          this.errors += `${files[i].name}: ${this.__('misc.error_file_type')}`;
        }

        fileSize += files[i].size;
      }

      if ((this.totalSizeUploaded + fileSize) > this.maxFileSize) {
        Vue.swal.fire({
          title: this.__('misc.error'),
          html: this.__('forms.Person.permission_tabs.documents.max-size'),
          icon: "error",
        });
        result = false
      } else if (this.errors.length > 0) {
        Vue.swal.fire({
          title: this.__('misc.error'),
          html: this.errors + ' <br/> ' + this.__('misc.validation_file_error'),
          icon: "error",
        });
        result = false;
      }

      this.totalSizeUploaded = result ? this.totalSizeUploaded + fileSize : this.totalSizeUploaded;

      this.errors = '';
      return result
    }
  },
};
</script>

<style scoped>
.nav-tabs {
  border-bottom: 1px solid #1767a2;
}

.card {
  border: none;
}

.container-file-upload {
  width: auto !important;
  border: 1px dashed #1767a2;
  padding: 30px;

}

.upload-icon {
  font-size: 40px;
}

.form-control {
  font-size: 100% !important;
}
</style>
